import { Button, Grid, MenuItem } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'
import { setError } from '../../../components/alerts'
import * as Yup from 'yup'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'

const validationFormik = Yup.object({
  idEmpresa: Yup.number().required('Campo Obrigatório!'),
  dsMovimento: Yup.string().required('Campo Obrigatório!'),
  tpMovimento: Yup.string().required('Campo Obrigatório!'),
  tpOrigem: Yup.string().required('Campo Obrigatório!'),
  vlMovimento: Yup.number()
    .required('Campo Obrigatório!')
    .moreThan(0, 'A quantidade deve ser maior que zero'),
})

const retornaEquipamento = (dados) => ({
  idMovimentacaoFinanceira: dados?.[0],
  idContaOrigem: dados?.[1]?.[0]?.[0],
  acContaOrigem: dados?.[1],
  idEmpresa: dados?.[2]?.[0]?.[0],
  acEmpresa: dados?.[2],
  dtMovimento: dados?.[3],
  tpMovimento: dados?.[4],
  vlMovimento: dados?.[5],
  dsMovimento: dados?.[6],
  dsObservacao: dados?.[7],
  idContaBancariaOrigem: dados?.[8]?.[0]?.[0],
  acContaBancariaOrigem: dados?.[8],
  idContaBancariadestino: dados?.[9]?.[0]?.[0],
  acContaBancariadestino: dados?.[9],
  idPlanoConta: dados?.[10]?.[0]?.[0],
  acPlanoConta: dados?.[10],
  idCentroCusto: dados?.[11]?.[0]?.[0],
  acCentroCusto: dados?.[11],
  tpOrigem: 'M',
})

const Edicao = ({ dados, voltar }) => {
  const salva = async (values) => {
    const payload = {
      ...values,
    }

    const res = await metodoPrograma('salva', payload)
    if (res.status) voltar()
    else setError(res.dsErro)
  }

  return (
    <Formik
      enableReinitialize
      initialValues={retornaEquipamento(dados)}
      validationSchema={validationFormik}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm, values, setFieldValue, errors }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="dsMovimento"
                label="Descrição do Movimento"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
                error={!!errors.dsMovimento}
                helperText={errors.dsMovimento?.message}
              />
            </Grid>
            {values.idContaOrigem && (
              <Grid item xs={12} md={12}>
                <Field
                  InputLabelProps={{ shrink: true }}
                  component={TextField}
                  name="idContaOrigem"
                  label="Conta de Origem"
                  fullWidth
                  disabled
                  margin="dense"
                  variant="outlined"
                  size="small"
                />
              </Grid>
            )}
            <Grid item xs={12} md={3}>
              <AutoComplete
                label="Empresa"
                metodo="buscaEmpresa"
                getOptionLabel={(item) =>
                  Array.isArray(item) && item.length > 0 ? `${item?.[1]}` : ''
                }
                value={values.acEmpresa}
                onChange={(_, v) => {
                  setFieldValue('idEmpresa', v?.[0]?.[0])
                  setFieldValue('acEmpresa', v)
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <AutoComplete
                InputLabelProps={{ shrink: true }}
                label="Plano de Conta"
                metodo="buscaPlanoConta"
                searchParams={{ idEmpresa: values.idEmpresa ?? undefined }}
                getOptionLabel={(item) =>
                  Array.isArray(item) && item.length > 0 ? `${item?.[1]}` : ''
                }
                value={values.acPlanoConta}
                onChange={(_, v) => {
                  setFieldValue('idPlanoConta', v?.[0]?.[0])
                  setFieldValue('acPlanoConta', v)
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <AutoComplete
                InputLabelProps={{ shrink: true }}
                label="Centro de Custo"
                metodo="buscaCentroCusto"
                getOptionLabel={(item) =>
                  Array.isArray(item) && item.length > 0 ? `${item?.[1]}` : ''
                }
                value={values.acCentroCusto}
                onChange={(_, v) => {
                  setFieldValue('idCentroCusto', v?.[0]?.[0])
                  setFieldValue('acCentroCusto', v)
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="tpMovimento"
                label="Tipo de Movimento"
                fullWidth
                select
                margin="dense"
                variant="outlined"
                size="small"
                error={!!errors.tpMovimento}
                helperText={errors.tpMovimento?.message}
              >
                <MenuItem key={0} value={'E'} className="flex gap-4">
                  Entrada
                </MenuItem>
                <MenuItem key={1} value={'S'} className="flex gap-4">
                  Saída
                </MenuItem>
                <MenuItem key={1} value={'T'} className="flex gap-4">
                  Transferência
                </MenuItem>
              </Field>
            </Grid>

            <Grid item xs={12} md={3}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="tpOrigem"
                label="Origem do Registro"
                fullWidth
                select
                disabled
                margin="dense"
                variant="outlined"
                size="small"
                error={!!errors.tpOrigem}
                helperText={errors.tpOrigem?.message}
              >
                <MenuItem key={0} value={'M'} className="flex gap-4">
                  Digitado Manual
                </MenuItem>
                <MenuItem key={1} value={'R'} className="flex gap-4">
                  Contas a Receber
                </MenuItem>
                <MenuItem key={1} value={'P'} className="flex gap-4">
                  Contas a Pagar
                </MenuItem>
              </Field>
            </Grid>
            <Grid item xs={12} md={3}>
              <Field
                InputLabelProps={{ shrink: true }}
                fullWidth
                tpSituacao
                variant="outlined"
                margin="dense"
                label="Valor"
                size="small"
                value={values.vlMovimento}
                component={CurrencyField}
                name="vlMovimento"
                onChange={(v) => {
                  setFieldValue('vlMovimento', v)
                }}
                error={!!errors.vlMovimento}
                helperText={errors.vlMovimento?.message}
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                component={TextField}
                name="dsObservacao"
                label="Observações"
                fullWidth
                multiline
                minRows={3}
                maxRows={10}
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
